const PASSWORD_UPDATE_ACTION_TYPES = {
  UPDATE_PASSWORD: "UPDATE_PASSWORD",
  UPDATE_PASSWORD_REQUEST: "UPDATE_PASSWORD_REQUEST",
  UPDATE_PASSWORD_SUCCESS: "UPDATE_PASSWORD_SUCCESS",
  UPDATE_PASSWORD_FAILURE: "UPDATE_PASSWORD_FAILURE",
  UPDATE_PASSWORD_RESET: "UPDATE_PASSWORD_RESET",
}

export default PASSWORD_UPDATE_ACTION_TYPES
